<div *transloco="let t" class="relative mobilescroll" cdkDrag cdkDragRootElement=".cdk-overlay-pane" cdkDragBoundary=".cdk-overlay-container">
	<button class="absolute right-2 top-2 z-10" mat-icon-button (click)="close(false)" [attr.aria-label]="t('commonActions.close')">
		<mat-icon>close</mat-icon>
	</button>
	<div class="cursor-move px-6 pt-4 pr-12 text-lg font-semibold" cdkDragHandle>
		{{ layoutService.isMobile() ? t('massPrint.mergedPdfOrZipMobile') : t('massPrint.mergedPdfOrZip') }}
	</div>
	<ng-container>
		<mat-accordion class="headers-align" multi>
			<mat-expansion-panel [disabled]="chosenTargetFormat !== 'DOCUMENT'" [expanded]="chosenTargetFormat === 'DOCUMENT'">
				<mat-expansion-panel-header>
					<div class="flex items-center w-full">
						<mat-panel-title class="w-[40%] flex-none">
							{{ layoutService.isMobile() ? t('massPrint.mergedPdfOrZipMobile') : t('massPrint.mergedPdfOrZip') }}
						</mat-panel-title>
						<mat-panel-description class="w-[40%] flex-none justify-start">
							{{
								layoutService.isMobile()
									? chosenFileFormat
										? t('massPrint.' + chosenFileFormat + 'Mobile')
										: ' '
									: chosenFileFormat
										? t('massPrint.' + chosenFileFormat)
										: ' '
							}}
						</mat-panel-description>
						<mat-icon [svgIcon]="icons.get('pdf')" class="w-[10%] flex-none"></mat-icon>
					</div>
				</mat-expansion-panel-header>
				<mat-radio-group [(ngModel)]="chosenFileFormat" class="radio-group">
					@for (option of fileFormats; track option) {
						<mat-radio-button [value]="option" class="radio-button">
							{{ option }}
						</mat-radio-button>
					}
				</mat-radio-group>
			</mat-expansion-panel>
		</mat-accordion>
	</ng-container>
	<ng-container>
		<div [ngClass]="!isMobile ? 'pb-4' : ''" class="flex flex-row justify-end items-center" mat-dialog-actions>
			<button (click)="close(true)" color="primary" mat-raised-button type="submit">
				<mat-icon>check</mat-icon>
				@if (!isMobile) {
					<span>{{ t('common.apply') }}</span>
				}
			</button>
		</div>
	</ng-container>
</div>
